import React from "react";
import { classes } from "@bloomberg/media-ui-core";
import typographyStyles from "@bloomberg/media-ui-tokens/css/typography.module.css";
import styles from "./snapshotDetail.module.css";
import UpdateHighlight from "~components/UpdateHighlight";

type SnapshotDetailProp = {
  field: string;
  fieldDetail: string | number | boolean | string[];
  isRealTime: boolean;
};
export default function SnapshotDetail(props: SnapshotDetailProp) {
  const { field, fieldDetail, isRealTime } = props;

  if (typeof fieldDetail === "boolean") return null;

  const realTimeDetail = Array.isArray(fieldDetail) ? (
    <>
      <UpdateHighlight value={fieldDetail[0]} />
      <span className={styles.seperator}>–</span>
      <UpdateHighlight value={fieldDetail[1]} />
    </>
  ) : (
    <UpdateHighlight value={fieldDetail} />
  );

  const detail = Array.isArray(fieldDetail) ? (
    <>
      <>{fieldDetail[0]}</>
      <span className={styles.seperator}>–</span>
      <>{fieldDetail[1]}</>
    </>
  ) : (
    <>{fieldDetail}</>
  );

  return (
    <div className={styles.snapshotDetail}>
      <div
        className={classes([styles.title, typographyStyles.coreShortTextXs])}
      >
        {field}
      </div>
      <div className={styles.detail}>
        {isRealTime ? realTimeDetail : detail}
      </div>
    </div>
  );
}
